<template>
  <label
    :for="id"
    class="bl-input-label"
    :class="[
      checked || indeterminate ? 'bl-input-label-checked' : '',
      disabled ? 'bl-input-label-disabled' : ''
    ]"
  >
    <input type="checkbox" class="bl-input" :id="id" @change="change" />
    <BlIcon
      v-if="checked"
      class="bl-input-icon"
      icon="check"
      color="secondary"
    />
    <BlIcon
      v-else-if="indeterminate"
      class="bl-input-icon"
      icon="minus"
      color="secondary"
    />
    <div v-if="tooltip" class="bl-input-tooltip">
      <BlTextBody3 class="bl-input-tooltip-text" :text="tooltip" />
    </div>
  </label>
</template>

<script>
import BlIcon from "./BlIcon.vue";
import BlTextBody3 from "./BlTextBody3.vue";

export default {
  components: {
    BlIcon,
    BlTextBody3
  },
  name: "BlButton",
  props: {
    checked: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    tooltip: { type: String, required: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    id() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-input-${combination}`;
    }
  },
  methods: {
    change() {
      if (!this.disabled) {
        this.$emit("changed", this.checked);
      }
    }
  }
};
</script>

<style scoped lang="scss">
label.bl-input-label {
  cursor: pointer;
  position: relative;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 2px;
  border: 1px solid var(--Slate-4, #eaecf0);
  background: var(--background-depth-one-color);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  input.bl-input {
    pointer-events: none;
    z-index: -1;
    position: absolute;
    opacity: 0;
  }
  .bl-input-icon {
    position: absolute;
    top: -0.0625rem;
    left: -0.0625rem;
    width: 1.125rem;
    height: 1.125rem;
  }
  .bl-input-tooltip {
    pointer-events: none;
    opacity: 0;
    position: absolute;
    top: calc(100% + 0.5rem);
    left: 50%;
    width: 8.375rem;
    padding: 0.75rem 1rem;
    box-sizing: border-box;
    background: var(--primary-color);
    border-radius: 10px;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    .bl-input-tooltip-text {
      color: #fff;
      text-align: center;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 99%;
      left: 50%;
      margin-left: -0.5rem;
      border-width: 0.5rem;
      border-style: solid;
      border-color: transparent transparent var(--primary-color) transparent;
    }
  }
  &.bl-input-label-disabled {
    cursor: default;
    background-color: var(--border-color) !important;
    border-color: var(--border-color) !important;
  }
  &.bl-input-label-checked {
    background: var(--primary-color);
    border-color: var(--primary-color);
  }
  &:hover {
    z-index: 99;
    .bl-input-tooltip {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlInputCheck.vue